module.exports = __webpack_public_path__ + "img/m-wash4-menu-desktop.7790d1b5.png";